import classNames from 'classnames';
import React from 'react';
import { FCC } from 'react';
import { IColumnBreakpoints, IColumnProps } from './types';

const getClasses = (prop: IColumnBreakpoints, extraClass: string = '') => {
  return Object.keys(prop).reduce<Record<string, boolean>>((map, breakpoint) => {
    const bp = breakpoint as keyof IColumnBreakpoints;
    const name = extraClass
      ? `col-${breakpoint}-${extraClass}-${prop[bp]}`
      : `col-${breakpoint}-${prop[bp]}`;
    map[name] = true;
    return map;
  }, {});
};

export const Column: FCC<IColumnProps> = (props) => {
  // If only a number for size is passed, we default to xs because it will apply to all higher breakpoints
  const sizeClasses = typeof props.size === 'number' ? { [`col-xs-${props.size}`]: true } : getClasses(props.size);
  let offsetClasses = {};
  let pushClasses = {};
  let pullClasses = {};

  if (props.offset) {
    offsetClasses =
      typeof props.offset === 'number'
        ? { [`col-xs-offset-${props.offset}`]: true }
        : getClasses(props.offset, 'offset');
  }

  if (props.push) {
    pushClasses =
      typeof props.push === 'number' ? { [`col-xs-push-${props.push}`]: true } : getClasses(props.push, 'push');
  }

  if (props.pull) {
    pullClasses =
      typeof props.pull === 'number' ? { [`col-xs-pull-${props.pull}`]: true } : getClasses(props.pull, 'pull');
  }

  const columnClasses = classNames({
    ...sizeClasses,
    ...offsetClasses,
    ...pushClasses,
    ...pullClasses,
  });
  return <div className={columnClasses}>{props.children}</div>;
};
